export default "__VITE_ASSET__CbEQim5g__"